import React, { memo } from 'react'
import { usePageWidth, LayoutBand, FlowGrid, colors, Card } from '@fs/zion-ui'
import { css } from '@emotion/core'
import GroupListHeader from './GroupListHeader'
import GroupCardContents from './GroupCardContents'
import GroupCardContentsPending from './GroupCardContentsPending'
import GroupCardContentsFailed from './GroupCardContentsFailed'

const wrapCss = css`
  height: 100%;
  display: flex;
  flex-flow: column;
`
/**
 *
 * @param {{refetchGroupList: () => Promise<void>
 * totalGroupCount: number | undefined
 * groups: import('@fs/zion-tree-types').GroupSummary[]
 * isResearcherGroupList?: boolean }} param0
 * @returns {JSX.Element}
 */

function GroupList({ refetchGroupList, totalGroupCount, groups, isResearcherGroupList }) {
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ lg: false, default: true })

  return (
    <div css={wrapCss} data-testid={isResearcherGroupList ? 'research-tree-page' : 'family-groups-page'}>
      <LayoutBand marginY="xs">
        <GroupListHeader
          isResearcherGroupList={isResearcherGroupList}
          totalGroupCount={totalGroupCount}
          refetchGroupList={refetchGroupList}
        />
      </LayoutBand>
      <LayoutBand marginY="xs" color={colors.gray03} growY>
        <FlowGrid gutters="xs" columnCount={isMobile ? 1 : 2}>
          {/* FlowGrid requires that the card is a direct child, it can't be in a separate component. */}
          {groups?.map((group, index) => {
            let Component = GroupCardContents
            const cardProps = {}

            if (group.memberStatus === 'PENDING') {
              cardProps.backgroundColor = colors.blue03
              Component = GroupCardContentsPending
            } else if (group.isFailed && !group.isProcessing) {
              cardProps.backgroundColor = colors.yellow03
              Component = GroupCardContentsFailed
            } else if (group.id) {
              cardProps.to = `/${isResearcherGroupList ? 'research-tree' : 'family'}/${group.id}`
            }
            if (group.isProcessing) {
              cardProps.backgroundColor = colors.blue02
            }
            const cardKey = group.id || `list-card-${index}`
            return (
              <Card {...cardProps} key={cardKey} data-testid="group-list-item" margins="xs">
                <Component group={group} refetchGroupList={refetchGroupList} />
              </Card>
            )
          })}
        </FlowGrid>
      </LayoutBand>
    </div>
  )
}

export default memo(GroupList)
